export const BREAKPOINT_SMALL = 767;



// WEBPACK FOOTER //
// ./src/config.js